import { render, staticRenderFns } from "./CustomerServiceFloat.vue?vue&type=template&id=16c97155&scoped=true"
import script from "./CustomerServiceFloat.vue?vue&type=script&lang=js"
export * from "./CustomerServiceFloat.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceFloat.vue?vue&type=style&index=0&id=16c97155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c97155",
  null
  
)

export default component.exports